import { X } from 'lucide-react';
import React from 'react';

export type ClearProps = {
  disabled?: boolean;
  onClick: () => void;
};

export const Clear: React.FC<ClearProps> = ({ disabled, onClick }) => (
  <button
    aria-label="Clear"
    className="flex items-center gap-1 text-xs px-2 py-1 rounded border border-gray-300 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
    disabled={disabled}
    onClick={onClick}
    type="button"
  >
    <X size={16} />
    <span>Clear</span>
  </button>
);
